import { useSelector } from 'react-redux';
import { getUserInventoryFilters } from '../../selectors';

export const useFastInventoryFilters = () => ({
  filters: useSelector(getUserInventoryFilters),
});
